import SvgIcon from "../svg-icon";

const NoData = (props) => {

    const {desc} = props

    return (
        <div className="note">
            <SvgIcon extra={'big-icon'} id={'empty-content'}/>
            {/*<p>{game?.name} has no active challenges</p>*/}
            <p>{desc}</p>
        </div>
    )
}


export default NoData
